import { useForm } from "react-hook-form";
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {Grid, TextField } from "@material-ui/core";
import { basic, validationMessages } from '../../../config/validations';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { getTransaction, getAllTransactions } from '../../../store/constructs/transactions/selectors';
import { getLuaEditorData } from "../../../store/constructs/handlers/selectors";
import { getAllEvents } from "../../../store/constructs/events/selectors";
import { handleSnackBar, invokePostService, setInnerScreenRender, setSelectedTransactionId } from '../../../store/global/actions';
import { getExternalFunctions } from "../../../store/constructs/clusterlets/selectors";
import CustomizedDialogs from "../../atoms/dialog";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export const CloneTransaction = (props) => {
    const { open, onClose, onCompletion, selectedTransaction } = props;
    const { register, handleSubmit, getValues, trigger, reset, formState: { errors }, control, setError } = useForm();
    const dispatch = useDispatch();
    const transactions = useSelector(getTransaction);
    const allTransactions = useSelector(getAllTransactions);
    const handlers = useSelector(getLuaEditorData);
    const events = useSelector(getAllEvents);
    const delegates = useSelector(getExternalFunctions);
    const history = useHistory();
    const name = `${selectedTransaction.name}_copy`;
    let [, , slug, id, tag] = history.location.pathname.split("/");

    const [disableClone, setDisableClone] = useState(false);

    useEffect(() => {
        reset({ name });
        return () => {
            reset({ name });
        };
    }, []);

    const messages = {
        ...validationMessages,
        validate: 'Duplicate transaction name given'
    }
    const duplicateTransaction = (field) => {
        let result = transactions.find(t => t.name == field);
        return result == undefined ? true : false;
    }
    
    const onSave = (data) => {
        setDisableClone(true);
        dispatch(invokePostService('cloneTransaction', {transaction: data, selectedTransaction:  selectedTransaction._id}, []))
                .then((clonedResponse) => {
                    if (clonedResponse.status && clonedResponse.data) {
                        onCompletion();             
                        history.push(`/blueprint/${slug}/${id}/transaction/${clonedResponse.data._id}`);
                        dispatch(setSelectedTransactionId(clonedResponse.data._id));
                        dispatch(setInnerScreenRender());
                    }else if (clonedResponse?.status == false && clonedResponse.errors !== undefined && clonedResponse.errors.length > 0) {
                        setDisableClone(false)
                        if (clonedResponse?.code === "600") {
                            clonedResponse?.errors?.forEach(error => {
                                setError(error.name, {message: error.message});
                            });
                        }
                    }else{
                        setDisableClone(false)
                        dispatch(handleSnackBar({ open: true, message: clonedResponse.message, severity: "error" }));
                    }
                })

        // let { clonedTransaction, 
        //     copiedNestedTransactions,
        //     totalCopiedEvents, 
        //     totalCopiedHandlers
        // } = cloneTransaction(allTransactions, events, handlers, delegates, selectedTransaction, data);
        // console.log({ clonedTransaction, copiedNestedTransactions, totalCopiedEvents, totalCopiedHandlers })
        // dispatch(addTransaction(clonedTransaction));
        // copiedNestedTransactions.forEach(transaction => {
        //     dispatch(addTransaction(transaction));
        // });
        // totalCopiedEvents.forEach(event => {
        //     dispatch(addAnEvent(event));
        // });

        // dispatch(updateFullHandlers(totalCopiedHandlers));
        // onCompletion();
        // dispatch(setSelectedTransactionId(clonedTransaction.id));
        // dispatch(reRenderInfoBuilder());
    }

    return (
        <CustomizedDialogs
                container_id={"clone_transaction_modal"}
				open={open}
				title="Clone Transaction"
				handleClose={onClose}
			>
				 <Grid id={"clone_transaction_content"} container direction={"row"} spacing={3}>
            <Grid item xs={12}>
                <TextField
                    InputLabelProps={{
                        shrink: true,
                    }}
                    autoFocus
                    size="small"
                    name="name"
                    fullWidth
                    type={"string"}
                    required={true}
                    label={"Name"}
                    placeholder={""}
                    variant="outlined"
                    error={errors?.name ? true : false}
                    helperText={errors?.name ? errors?.name?.message ? errors.name.message : messages[errors?.name?.type] : ''}
                    inputRef={register({ ...basic, validate: duplicateTransaction })}
                />
            </Grid>

            <Grid item xs={12}>
                <TextField
                    id="description"
                    InputLabelProps={{
                        shrink: true,
                    }}
                    error={Boolean(errors?.description)}
                    type={"text"}
                    fullWidth
                    rows={4}
                    multiline={true}
                    label={"Description"}
                    placeholder={"Description"}
                    variant="outlined"
                    name="description"
                    inputRef={register}
                />
            </Grid>


            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <UpdateCancel updateDisable={disableClone} onUpdate={handleSubmit(onSave)} onCancel={onClose} content="Clone" />
            </Grid>
        </Grid>
			</CustomizedDialogs>
    )

}